import React, { MouseEventHandler, ReactElement } from 'react'

function ButtonFullWidth(
  props: Readonly<{
    children: ReactElement | string;
    onClick: MouseEventHandler<HTMLButtonElement>;
  }>
) {
  return (
    <button
      className={
        "w-full  shadow-md transition duration-200 text-left rounded-md " +
        "pl-[20px] py-4 text-lg " + // mobile: more padding, bigger text
        "sm:py-3 sm:text-base " +   // tablet/desktop: normal padding/text
        "hover:bg-lightbg-headerSecondary hover:scale-105"
      }
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

export default ButtonFullWidth

